const TIMEOUT = 30000

export class ResponseError extends Error {
  public response: Response

  constructor(response: Response) {
    super(response.statusText)
    this.response = response
  }
}

function parseJSON(response: Response) {
  if (response.status === 204 || response.status === 205) {
    return null
  }
  return response.json()
}

function checkStatus(response: Response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  }
  const error = new ResponseError(response)
  error.response = response
  return error
}

async function fetchWithTimeout(resource: RequestInfo, options?: RequestInit) {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), TIMEOUT)

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal
  })
  clearTimeout(id)

  return response
}

export default async function request<T>(
  url: string,
  method: string,
  data?: {},
  authCode?: string,
  onError?: (err: ResponseError, params?: any) => void
): Promise<T | null> {
  const requestPerams = {
    method,
    headers: {
      ...(authCode ? { Authorization: authCode } : {}),
      'Content-Type': 'application/json'
    },
    ...(data ? { body: JSON.stringify(data) } : {})
  }
  const fetchResponse = await fetchWithTimeout(url, requestPerams)

  const response = checkStatus(fetchResponse)
  if (response instanceof ResponseError) {
    if (onError) {
      onError(response, { url, ...requestPerams })
    }
    console.log(response)
    return null
  }

  const res = parseJSON(response)
  // console.log('error', res)
  return res
}
